import type { ComponentProps } from 'react';
import { cn } from './ui/utils';

/**
 * PageContainer
 * Provides consistent page background with org-aware color support.
 * Replaces hardcoded "bg-muted/40" patterns across pages.
 * Automatically respects organization color scheme from RootLayout.
 */
export function PageContainer({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'min-h-screen bg-muted text-foreground',
        className,
      )}
      {...props}
    />
  );
}

export default PageContainer;
